import React from "react";

// Digital Mother Earnings Items
const earningsItems = [
  "Buy MATRIKA Digital Immersive Monthly Magazine and Refer",
  "Buy Other Digital Immersive Monthly Magazines and Refer",
  "Explore Think5Whys BookWorld-Refer-Earn",
  "Explore Think5Whys Marketplace-Buy-Refer-Earn",
  "KharchoJeeto: Win Prizes",
  "Marksheet Contest: Win Prizes",
  "Engage With Think5Whys Ads and Earn (Coming Soon)"
];

const MatrikaHowMotherEarns = () => {
  return (
    <section className="py-4 px-4 md:px-20 bg-gray-6000 min-h-screen">
      <h2 className="text-2xl font-bold text-center mb-4 text-orange-400">
        Digital Mother Earnings
      </h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2">
        {earningsItems.map((item, idx) => (
          <div
            key={idx}
            className="bg-gray-600 rounded-2xl shadow-lg p-6 hover:shadow-2xl transform hover:-translate-y-1 transition duration-300 flex flex-col justify-between"
          >
            {/* Icon */}
            <div className="flex items-center justify-center mb-4">
              <span className="text-2xl">💖</span>
            </div>

            {/* Title / Label */}
            <h3
              className="text-sm font-semibold text-yellow-200 text-center mb-3"
              title={item}
            >
              {item}
            </h3>

            {/* SN badge */}
            <div className="text-center text-white font-bold bg-orange-400 rounded-full w-8 h-8 mx-auto flex items-center justify-center">
              {idx + 1}
            </div>
          </div>
        ))}
      </div>

      {/* Process Section after 5 items */}
      {earningsItems.length > 5 && (
        <div className="bg-gray-700 rounded-lg shadow-md p-6 mt-10">
          <h3 className="text-yellow-200 font-semibold text-lg mb-3 text-center">
            Next Steps / Process
          </h3>
          <ul className="list-disc list-inside text-white space-y-1 text-sm md:text-base">
            <li>Step 1: Choose your preferred earning method above.</li>
            <li>Step 2: Follow instructions for referring or participating.</li>
            <li>Step 3: Track your rewards in your dashboard.</li>
            <li>Step 4: Redeem prizes or bonuses as per guidelines.</li>
          </ul>
        </div>
      )}
    </section>
  );
};

export default MatrikaHowMotherEarns;
